module.exports = __webpack_public_path__ + "static/media/gravure7.3ead46e3.jpg";